import { Box, Flex, SimpleGrid, Stat, StatHelpText, StatNumber, Text } from '@chakra-ui/react'
import { RiAlertLine, RiCheckboxCircleLine, RiMoneyDollarCircleLine, RiPercentLine } from 'react-icons/ri'
import { FinancialRecurringTotals } from '../../../Interfaces/financialRecurring'

const formatCurrency = (value: number) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(value ?? 0)

interface SummaryCardsProps {
  totals?: FinancialRecurringTotals
}

const SUMMARY_CONFIG = [
  {
    label: 'Total previsto (mês)',
    getValue: (totals: FinancialRecurringTotals) => formatCurrency(totals.totalPrevisto),
    getHelper: (totals: FinancialRecurringTotals) => 'Baseado em ' + formatCurrency(totals.totalPrevisto),
    icon: RiMoneyDollarCircleLine,
    color: 'blue.400',
  },
  {
    label: 'Total pago (mês)',
    getValue: (totals: FinancialRecurringTotals) => formatCurrency(totals.totalPago),
    getHelper: (totals: FinancialRecurringTotals) => formatCurrency(totals.totalPago) + ' já pagos/recebidos',
    icon: RiCheckboxCircleLine,
    color: 'green.400',
  },
  {
    label: 'Total em aberto (mês)',
    getValue: (totals: FinancialRecurringTotals) => formatCurrency(totals.totalAberto),
    getHelper: (totals: FinancialRecurringTotals) => formatCurrency(totals.totalAberto) + ' aguardando',
    icon: RiAlertLine,
    color: 'orange.300',
  },
  {
    label: 'Adimplência',
    getValue: (totals: FinancialRecurringTotals) => totals.percentualAdimplencia.toFixed(2) + '%',
    getHelper: (totals: FinancialRecurringTotals) => totals.percentualAdimplencia.toFixed(2) + '% do previsto foi pago',
    icon: RiPercentLine,
    color: 'purple.300',
  },
]

export function SummaryCards({ totals }: SummaryCardsProps) {
  if (!totals) {
    return null
  }

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={6}>
      {SUMMARY_CONFIG.map((item) => (
        <Box key={item.label} bg="gray.800" borderRadius="md" p={6} boxShadow="lg">
          <Flex align="center" justify="space-between" mb={4}>
            <Text fontWeight="medium">{item.label}</Text>
            <item.icon fontSize="2xl" color={item.color} />
          </Flex>
          <Stat>
            <StatNumber fontSize="2xl" fontWeight="bold">
              {item.getValue(totals)}
            </StatNumber>
            <StatHelpText color="gray.400">{item.getHelper(totals)}</StatHelpText>
          </Stat>
        </Box>
      ))}
    </SimpleGrid>
  )
}
